export default "__VITE_ASSET__CGdM8WXZ__"